const translations: Record<string, string> = {
  "ak_fin2_uah_mwh": "{{v}} UAH/MWh",
  "ak_fin2_dam": "DAM",
  "ak_fin2_index": "index",
  "ak_fin2_confirm": "Confirm?",
  "ak_fin2_no_terms_yet": "No terms yet.",
  "ak_fin2_press_add_term": "Press “Add term”.",
  "ak_fin2_term_activated": "Term activated.",
  "ak_fin2_term_completed": "Term completed.",
  "ak_fin2_failed_to_change_the_status": "Failed to change the status",
  "ak_fin2_draft_deleted": "Draft deleted.",
  "ak_fin2_failed_to_delete": "Failed to delete",
  "ak_fin2_saved": "Saved.",
  "ak_fin2_terms_directory": "Terms directory",
  "ak_fin2_add_term": "Add term",
  "ak_fin2_asset": "Asset",
  "ak_fin2_seller": "Seller",
  "ak_fin2_buyer": "Buyer",
  "ak_fin2_sale_type": "Sale type",
  "ak_fin2_model": "Model",
  "ak_fin2_price_formula": "Price / formula",
  "ak_fin2_validity_period": "Validity period",
  "ak_fin2_vat": "VAT",
  "ak_fin2_status": "Status",
  "ak_fin2_actions": "Actions",
  "ak_fin2_loading": "Loading…",
  "ak_fin2_incl_vat": "incl. VAT",
  "ak_fin2_excl_vat": "excl. VAT",
  "ak_fin2_edit": "Edit",
  "ak_fin2_activate": "Activate",
  "ak_fin2_complete": "Complete",
  "ak_fin2_confirm_draft_deletion": "Confirm draft deletion",
  "ak_fin2_delete_draft": "Delete draft",
  "ak_fin2_the_database_enforces_the_rule_one_act": "The database enforces the rule “one active term per asset + period”: a second term with an overlapping period cannot be activated.",
  "ak_fin2_price_x": "Price = {{base}} ± X%",
  "ak_fin2_price": "Price = {{base}} {{sign}} {{n}}%",
  "ak_fin2_rounded_to_2_decimals_final_hourly_pri": "rounded to 2 decimals, final hourly price only",
  "ak_fin2_failed_to_save": "Failed to save",
  "ak_fin2_edit_term": "Edit term",
  "ak_fin2_new_purchase_and_sale_term": "New purchase and sale term",
  "ak_fin2_asset_and_parties": "Asset and parties",
  "ak_fin2_asset_2": "Asset *",
  "ak_fin2_select_an_asset": "— select an asset —",
  "ak_fin2_short_name": "Short name",
  "ak_fin2_buyer_type": "Buyer type *",
  "ak_fin2_contract_and_period": "Contract and period",
  "ak_fin2_contract_number": "Contract number",
  "ak_fin2_contract_date": "Contract date",
  "ak_fin2_valid_from": "Valid from *",
  "ak_fin2_valid_to": "Valid to *",
  "ak_fin2_sale_type_2": "Sale type *",
  "ak_fin2_green_tariff_validity_end": "Green tariff validity end",
  "ak_fin2_neurc_resolution_no_and_date": "NEURC resolution (no. and date)",
  "ak_fin2_price_model": "Price model",
  "ak_fin2_model_2": "Model *",
  "ak_fin2_price_uah_mwh": "Price, UAH/MWh *",
  "ak_fin2_base_index": "Base index *",
  "ak_fin2_markup_discount": "Markup/discount, % *",
  "ak_fin2_other": "Other",
  "ak_fin2_incl_vat_2": "Incl. VAT",
  "ak_fin2_cancel": "Cancel",
  "ak_fin2_saving": "Saving…",
  "ak_fin2_save": "Save",
  "ak_fin2_create": "Create",
};

export default translations;
